import PlateGroupsService from '@/application/services/PlateGroups'
import PlatesProvider from '../../application/providers/PlatesProvider';
import Util from "@/application/libs/util"
import util from '../../application/libs/util';
import { t } from 'i18next'

const _filauxpratFormmater = (o) => {
    let value = o.value;
    let returnValue = "";
    if (value) {
        returnValue = value === 'P' ? "Padrão" : "Local";
    }
    return returnValue;
};

const _filauxpratFormmaterTurbo = function(o){
    if(o.value === void 0){
        return ""
    } else if(o.value === "P") 
        return "Padrão";
    else
        return "Local"; 
    
}

const currencyValueFormatter = ({ value }) => {
    return value && !Number.isNaN(value) ? Number(value) : '';
};

/**
 * @param {String} baseStr 
 * @param {String} maskStr 
 * @param {String} char 
 */
const insertChar = (baseStr, maskStr, char) => {
    if(baseStr === undefined){
        return undefined;
    }
    var newStr = "";
    var offset = 0;

    for (var i = 0; i < maskStr.length && i < baseStr.length + offset; i++) {
        if (maskStr[i] === char) {
            newStr += char;
            offset++;
        } else {
            newStr += baseStr[i - offset];
        }
    }
    return newStr;
};


const focusCell = (grid, fieldName, rowIndex = 0) => {
    grid.gridControl.clearFocusedCell(); // clear current focused cells
    grid.gridControl.ensureColumnVisible(fieldName);
    grid.gridControl.startEditingCell({ rowIndex, colKey: fieldName});
};

const savePlateGroupStandard = ({data, colDef}) => {
    if(!data.__removed){
        PlateGroupsService.savePlateGroupStandard(data, colDef.field).then((result) => {
            if (result && result.error) {
                throw result;
            } else if(result){
                plateGroupStandardGridConfig.enableSelection();
                if(data.__is_new_row){
                    let key = data.CDPADGRUPOPRATO;
                    key = key.padStart(10, 0);
                    plateGroupStandardGridConfig.reloadData().then(a => {
                        let newElIndex = a.findIndex(ae => ae.CDPADGRUPOPRATO === key);
                        plateGroupStandardGridConfig.gridControl.ensureIndexVisible(newElIndex, "top");
                    });
                }
                Util.showSuccessNotification({ title: t('saved_dish_group_default')});
            }
        }).catch((e = {}) => {
            Util.showErrorNotification({ title: t('unable_to_save_dish_group_pattern'), text: e.error });
        });
    }
};
const savePlateGroupGrouping = ({data, colDef}) => {
    if(data.__removed) return;

    const isNewRow = !data.NRAGRUPGRPRAT;

    PlateGroupsService.savePlateGroupGrouping(data, colDef.field)
        .then((result) => {
            if (!result) return;
            
            if (result.error) throw result;

            if (isNewRow) {
                plateGroupGroupingGridConfig.enableSelection();
                const resultKey = result.dataset && result.dataset.data && result.dataset.data[0];
                const key = Number(resultKey || data.NRAGRUPGRPRAT).toString();

                plateGroupGroupingGridConfig.reloadData().then((rows) => {
                    const newElementIndex = rows.findIndex((row) => row.NRAGRUPGRPRAT === key);
                    plateGroupGroupingGridConfig.gridControl.ensureIndexVisible(newElementIndex, "top");
                });
            }

            Util.showSuccessNotification({ title: t('saved_dish_group_grouping')});
        })
        .catch((e = {}) => {
            Util.showErrorNotification({ title: t('unable_to_save_dish_group_grouping'), text: e.error });
        });
};

const refreshGrouplessRowLinkingState = ({ data, node }) => {
    if (node && grouplessPlatesGridConfig.updateRowNode) {
        grouplessPlatesGridConfig.updateRowNode({ data, node, force: true });
        return;
    }

    const gridApi = grouplessPlatesGridConfig && grouplessPlatesGridConfig.advancedOptions && grouplessPlatesGridConfig.advancedOptions.api;

    if (!gridApi || !gridApi.refreshCells) return;

    gridApi.refreshCells({ force: true });
};

const updateGrouplessRowLinkingState = ({ data, node, isLinking }) => {
    if (!data)  return;

    data.__linking = Boolean(isLinking);
    refreshGrouplessRowLinkingState({ data, node });
};

const saveGrouplessPlates = ({data, rowIndex, node}) => {
    if (!data || !data.NRGRUPOPRATOSERV)  return;

    updateGrouplessRowLinkingState({ data, node, isLinking: true });

    PlateGroupsService.saveGrouplessPlates(data).then((result) => {
        if (result && result.error) {
            throw result;
        } else if(result){
            let oldRowData = grouplessPlatesGridConfig.getRowData();
            oldRowData.splice(rowIndex, 1)
            grouplessPlatesGridConfig.setRowData(oldRowData);
            Util.showSuccessNotification({ title: t('linked_dish')});
        }
    }).catch((e = {}) => {
        updateGrouplessRowLinkingState({ data, node, isLinking: false });
        Util.showErrorNotification({ title: t('unable_to_save_dish'), text: e.error });
    });
};

const savePlateGroups = function(params){
    PlateGroupsService.savePlateGroups(params.data)
        .then((groupServCode)=>{
            if(params.data.__is_new_row){
                params.data.__is_new_row = false;
                params.data.NRGRUPOPRATOSERV = groupServCode;
                groupGridConfiguration.isAddingNewRow = false;
                groupGridConfiguration.enableSelection();
            }
      
            onGroupRowClicked(params);

            let cell = groupGridConfiguration.gridControl.getFocusedCell();
            if ( cell ) {
                groupGridConfiguration.gridControl.setFocusedCell( cell.rowIndex, cell.column );
            }

            Util.showSuccessNotification({
                title: t('record_inserted_successfully'),
                text:''
            })
        })
        .catch(error=>{
            let errorMsg = { 
                title: t('unable_to_save_dish_group'), 
                text: t('fill_in_all_fields')
            };

            if(error=='INCOMPLETE_FIELDS'){
                Util.showNotification(errorMsg);
            } else if(error=='INVALID_FIELDS'){
                Util.showErrorNotification(errorMsg);
            }
        });
};

const delPlateGroup = function(params, modal){
    let groupGrid = serviceInstance.groupGridConfiguration;
    let groupGridApi = serviceInstance.groupGridConfiguration.gridControl;
    let groupGridRowData = groupGrid.getRowData();
    let selectedRow = groupGridApi.getSelectedRows();
    
    if(selectedRow.length === 1){
        util.showConfirmationDialog(modal, function(){
            PlateGroupsService.delPlateGroup(selectedRow[0]).then((response)=>{
                if(response.error){
                    Util.showErrorNotification({
                        title: t('invalid_deletion'),
                        text: t(response.error)
                    })
                } else {
                    Util.spliceOnCondition(groupGridRowData, (data)=>data == selectedRow[0]);
                    groupGrid.setRowData(groupGridRowData);
                    serviceInstance.platesGridConfiguration.setRowData([]);
                    serviceInstance.platesGridConfiguration.gridControl.hideOverlay();
                    serviceInstance.platesGridConfiguration.hideFilterOverlay = false;
                    serviceInstance.platesGridConfiguration.showLoadingOverlay = false;
                    serviceInstance.platesGridConfiguration.disablePlateAdd = true;
                    serviceInstance.platesGridConfiguration.disablePlateDel = true;
    
                    Util.showSuccessNotification({
                        title: t('successfully_deleted_record'),
                        text:''
                    })
                }
            });
        }, t('are_you_sure_you_want_to_delete_dish_group'));
    } else {
        Util.showErrorNotification({
            title: t('invalid_deletion'),
            text: t('select_a_record_to_delete')
        })
    }
};

const exportGroupPlate = function(){
    return PlateGroupsService.getExportPlatesGroup();
};

const saveNewPlate = function(params){
    let groupGrid = serviceInstance.groupGridConfiguration.gridControl;
    PlateGroupsService.saveNewPlate(params.data, groupGrid.getSelectedRows()[0])
        .then((plateCode)=>{
            params.data.__is_new_row = false;
            params.data.NRITGRUPOPRATOSERV = plateCode[0];
            
            platesGridConfiguration.isAddingNewRow = false;
            platesGridConfiguration.enableSelection();

            let cell = platesGridConfiguration.gridControl.getFocusedCell();
            if ( cell ) {
                platesGridConfiguration.gridControl.setFocusedCell( cell.rowIndex, cell.column );
            }

            Util.showSuccessNotification({
                title: t('record_inserted_successfully'),
                text:''
            })
        })
        .catch(error=>{
            if(error=='INVALID_FIELDS'){
                Util.showErrorNotification({ 
                    title: t('unable_to_save_dish_group'), 
                    text: t('fill_in_all_fields')
                });
            }
        });
};

/**
 * On plate double clicked show plate recipe.
 * 
 * @param {Object} params
 */
const onPlateRowDbClicked = function (params){
    if(!params.data.__is_new_row){
        PlateGroupsService.getPlateRecipe(params.data).then(data=>{
            recipeGrid.__data = data;
            
            serviceInstance.vueContext.$modal.show('recipe-modal', {}, {
                height:'auto',
                clickToClose: true
            });
        });
    }
};

const delPlateRegister = function(params){
    let platesGrid = serviceInstance.platesGridConfiguration.gridControl;
    let selectedRows = platesGrid.getSelectedRows();

    if(selectedRows.length){
        PlateGroupsService.delPlateRegister(selectedRows.map(row=>row.NRITGRUPOPRATOSERV)).then(()=>{
            platesGrid.updateRowData({remove:selectedRows})
            
            Util.showSuccessNotification({
                title: t('successfully_deleted_record'),
                text:''
            })
        });
    } else {
        Util.showErrorNotification({
            title: t('invalid_deletion'),
            text: t('select_a_record_to_delete')
        })
    }
};

const deletePlateGroupStandard = (plateGroupStandardPanel) => {
    plateGroupStandardGridConfig.deleteCheckedRows(PlateGroupsService.deletePlateGroupStandard)
    .then(() => plateGroupStandardPanel.hasCheckedRows = false)
    .catch(e => {
        Util.showErrorNotification({ title: t('error_deleting_cymbal_group_pattern'), text: e.error })
    });
};

const deletePlateGroupGrouping = (plateGroupGroupingPanel) => {
    plateGroupGroupingGridConfig.deleteCheckedRows(PlateGroupsService.deletePlateGroupGrouping)
    .then(() => plateGroupGroupingPanel.hasCheckedRows = false)
    .catch(e => {
        Util.showErrorNotification({ title: t('error_deleting_dish_group_grouping'), text: e.error })
    });
};

const callProcedureExportCadOtimizador = (FILISERV, TABLE, ITEMS, MODE, PLATEGRID) => {
    return PlatesProvider.callProcedureExportCadOtimizador(FILISERV, TABLE, ITEMS, MODE, PLATEGRID);
};

const loadPlatesByGroup = (groupCode) => {
    if(!groupCode){
        return Promise.resolve();
    }

    serviceInstance.platesGridConfiguration.showLoadingOverlay = true;

    return PlateGroupsService.getPlatesByGroup(groupCode)
        .then(data => {
            serviceInstance.platesGridConfiguration.setRowData(data);
            serviceInstance.platesGridConfiguration.hideFilterOverlay = true;
            serviceInstance.platesGridConfiguration.disablePlateAdd = false;
            serviceInstance.platesGridConfiguration.disablePlateDel = false;
        })
        .finally(() => {
            serviceInstance.platesGridConfiguration.showLoadingOverlay = false;
        });
};

/**
 * On Click group row, set a filter into plates
 * grid to show only plates related with clicked group.
 */
const onGroupRowClicked = (params)=>{
    if(params.data && params.data.NRGRUPOPRATOSERV && params.data.NRGRUPOPRATOSERV.length){
        loadPlatesByGroup(params.data.NRGRUPOPRATOSERV);
    }
};

const plateGroupStandardGridConfig = {
    columnDefs: [
        { headerValueGetter: ()=> {return t('code') } , field: "CDPADGRUPOPRATO", checkboxSelection: true, 
            filterParams: {defaultOption: 'startsWith'}, editable: (e) => e.data.__is_new_row
        },
        { headerValueGetter: ()=> {return t('name') } , field: "NMPADGRUPOPRATO"}
    ],
    defaultColDef: {
        resizable: true, 
         
        checkboxSelection: false, 
        editable: true,
        sortable: true,
        filter: true
    },
    dataSource: PlateGroupsService.getPlateGroupStandard,
    onCellValueChanged: savePlateGroupStandard,
};

const plateGroupGroupingGridConfig = {
    columnDefs: [
        { headerValueGetter: ()=> {return t('code') } , field: "CDAGRUPGRPRAT", checkboxSelection: true, 
            filterParams: {defaultOption: 'startsWith'}, editable: (e) => e.data.__is_new_row
        },
        { headerValueGetter: ()=> {return t('name') } , field: "NMAGRUPGRPRAT"}
    ],
    defaultColDef: {
        resizable: true, 
         
        checkboxSelection: false, 
        editable: true,
        sortable: true,
        filter: true
    },
    dataSource: PlateGroupsService.getPlateGroupGrouping,
    onCellValueChanged: savePlateGroupGrouping,
};

const grouplessPlatesGridConfig = {
    columnDefs: [
        {
            headerValueGetter: ()=> {return t('tree') },
            field: "CDFILAUXPRAT",
            valueFormatter: _filauxpratFormmaterTurbo,
            sortable: true,
            filter: null,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            maxWidth: 120
        },
        { headerValueGetter: ()=> {return t('code') } , field: "CDPRATO", 
            filterParams: {defaultOption: 'startsWith'},
            // valueFormatter: ({ value }) => insertChar(value, serviceInstance.CDPICTPRAT, ".")
            // valueFormatter: ({value}) => value
        },
        { headerValueGetter: ()=> {return t('name') } , field: "NMPRATO"},
        { headerValueGetter: ()=> {return t('recipe') } , field: "RECEITA", sortable: true, filter: null},
        { headerValueGetter: ()=> {return t('last_update') } , field: "DTULTATURECE", sortable: true, filter: null},
        {
            headerValueGetter: ()=> {return t('group_of_dishes') },
            field: "GRPPRAT",
            cellEditor: "vSelectCellEditor",
            cellRenderer: (params) => {
                const value = (params && params.value) || '';

                if (value) {
                    return value;
                }

                return `<span class="groupless-group-dropdown-hint">${t('plate_group_select_group_dropdown_hint')} <i class="fas fa-caret-down"></i></span>`;
            },
            cellEditorParams: {
                optionsSearchFunction: () => PlateGroupsService.getGroupsForGrouplessPlates(),
                valueColumn: "NRGRUPOPRATOSERV",
                labelColumn: "NMGRUPOPRATO",
                appendToBody: true,
                remoteFilter: false,
                searchableColumns: ["NMGRUPOPRATO"],
                outDataColumns: ["NMAGRUPGRPRAT", "NRGRUPOPRATOSERV"]
            },
            sortable: true, filter: null, editable: true
        },
        {
            headerName: '',
            field: 'loader',
            width: 46,
            minWidth: 46,
            maxWidth: 46,
            sortable: false,
            filter: false,
            suppressMenu: true,
            editable: false,
            cellRenderer: (params) => {
                if (params && params.data && params.data.__linking) {
                    return '<span class="groupless-row-linking-indicator"><i class="fas fa-spinner fa-spin"></i></span>';
                }

                return '';
            }
        }
    ],
    defaultColDef: {
        resizable: true, 
         
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true
    },
    rowSelection: "multiple",
    suppressRowClickSelection: true,
    dataSource: PlateGroupsService.getGrouplessPlates,
    onCellValueChanged: saveGrouplessPlates,
};

const groupGridConfiguration = {
    columnDefs: [
        {
            headerValueGetter: () => { return t('group_code') },
            field: "CDAGRUPGRPRAT",
            checkboxSelection: false,
            filter: "agTextColumnFilter",
            resizable: true,
            sortable: true,
            maxWidth: 150,
            onCellDoubleClicked: ({ rowIndex }) => focusCell(groupGridConfiguration, "NMAGRUPGRPRAT", rowIndex),
            onCellClicked: (params) => {
                if (params.data && params.data.NRGRUPOPRATOSERV && params.data.NRGRUPOPRATOSERV.length) {
                    loadPlatesByGroup(params.data.NRGRUPOPRATOSERV);
                }
            }
        },
        {
            headerValueGetter: () => { return t('groupings') },
            field: "NMAGRUPGRPRAT",
            checkboxSelection: false,
            filter: "agTextColumnFilter",
            resizable: true,
            sortable: true,
            maxWidth: 250,
            cellEditor: "vSelectCellEditor",
            editable: true,
            cellEditorParams: {
                optionsSearchFunction: () => PlateGroupsService.getGroupsetToAdd(),
                valueColumn: "NRAGRUPGRPRAT",
                labelColumn: "NMAGRUPGRPRAT",
                searchableColumns: ["NMAGRUPGRPRAT"],
                outDataColumns: ["CDAGRUPGRPRAT"]
            },
            onCellClicked: (params) => {
                if (params.data && params.data.NRGRUPOPRATOSERV && params.data.NRGRUPOPRATOSERV.length) {
                    loadPlatesByGroup(params.data.NRGRUPOPRATOSERV);
                }
            }
        },
        {
            headerValueGetter: () => { return t('code') },
            field: "CDGRUPOPRATO",
            checkboxSelection: false,
            filter: "agTextColumnFilter",
            resizable: true,
            sortable: true,
            maxWidth: 150,
            onCellDoubleClicked: ({ rowIndex }) => focusCell(groupGridConfiguration, "NMGRUPOPRATO", rowIndex),
            onCellClicked: (params) => {
                if (params.data && params.data.NRGRUPOPRATOSERV && params.data.NRGRUPOPRATOSERV.length) {
                    loadPlatesByGroup(params.data.NRGRUPOPRATOSERV);
                }
            }
        },
        {
            headerValueGetter: () => { return t('group') },
            field: "NMGRUPOPRATO",
            checkboxSelection: false,
            filter: "agTextColumnFilter",
            resizable: true,
            sortable: true,
            maxWidth: 250,
            editable: params => params.data.__is_new_row,
            cellEditor: "vSelectCellEditor",
            cellClass: ["select-350"],
            cellEditorParams: {
                optionsSearchFunction: () => PlateGroupsService.getGroupsToAdd(),
                valueColumn: "CDPADGRUPOPRATO",
                labelColumn: "NMPADGRUPOPRATO",
                searchableColumns: ["NMPADGRUPOPRATO"],
                outDataColumns: ["CDGRUPOPRATO"]
            },
            onCellClicked: (params) => {
                if (params.data && params.data.NRGRUPOPRATOSERV && params.data.NRGRUPOPRATOSERV.length) {
                    loadPlatesByGroup(params.data.NRGRUPOPRATOSERV);
                }
            }
        },
        {
            headerValueGetter: () => { return t('nickname') },
            field: "NMFANTGRUPOPRATOSERV",
            cellClass: ["select-350"],
            filter: "agTextColumnFilter",
            editable: true,  
            resizable: true,
            sortable: true,
            maxWidth: 250,
            cellEditor: 'agTextCellEditor',
            onCellClicked: (params) => {
                if (params.data && params.data.NRGRUPOPRATOSERV && params.data.NRGRUPOPRATOSERV.length) {
                    loadPlatesByGroup(params.data.NRGRUPOPRATOSERV);
                }
            }
        }
    ],
    dataSource: function () {
        return Util.ifFilterSelected(PlateGroupsService.getPlatesGroups).then((data) => {
            serviceInstance.platesGridConfiguration.setRowData([]);
            serviceInstance.platesGridConfiguration.gridControl.hideOverlay();
            serviceInstance.platesGridConfiguration.hideFilterOverlay = false;
            serviceInstance.platesGridConfiguration.showLoadingOverlay = false;
            serviceInstance.platesGridConfiguration.disablePlateAdd = true;
            serviceInstance.platesGridConfiguration.disablePlateDel = true;

            return data;
        })
    },
    rowSelection: 'single',
    onCellValueChanged: savePlateGroups
};

const platesGridConfiguration = {
    columnDefs:[
        {
            headerValueGetter: ()=> {return t('tree') } , field: "ARVOREPRATO", checkboxSelection: true, filter: "agTextColumnFilter",
            resizable: true, sortable: true, maxWidth: 150, valueFormatter: _filauxpratFormmater,
            onCellDoubleClicked: ({rowIndex}) => focusCell(platesGridConfiguration, "NMPRATO", rowIndex)
        },
        {
            headerValueGetter: ()=> {return t('code') } , field: "CDPRATO", checkboxSelection: false, filter: "agTextColumnFilter",
            resizable: true, sortable: true, maxWidth: 150,
            onCellDoubleClicked: ({rowIndex}) => focusCell(platesGridConfiguration, "NMPRATO", rowIndex),
            valueFormatter: ({ value }) => insertChar(value, serviceInstance.CDPICTPRAT, ".")
        },
        {
            headerValueGetter: ()=> {return t('plates') } , field: "NMPRATO", checkboxSelection: false, filter: "agTextColumnFilter",
            resizable: true, sortable: true,
            maxWidth: 250, editable: params => params.data.__is_new_row,
            cellClass: ["select-350"], cellEditor: "vSelectCellEditor", 
            cellEditorParams: {
                optionsSearchFunction: Util.debounce((search)=>{
                    return PlateGroupsService.getNewPlatesToAdd(search);
                }, 400),
                valueColumn: "CDPRATO",
                labelColumn: "NMPRATO",
                searchableColumns: ["NMPRATO", "CDPRATO"],
                outDataColumns: [
                    'ARVOREPRATO',
                    'CDFILAUXPRAT',
                    'CDPRATO',
                    // 'NMPRATO',
                    'TIPO_RECEITA',
                    'DTULTATURECE'
                ]
            }
        },
        {
            headerValueGetter: ()=> {return t('recipe') } , field: "TIPO_RECEITA", checkboxSelection: false, filter: "agTextColumnFilter",
            resizable: true, sortable: true,
            maxWidth: 150
        },
        {
            headerValueGetter: ()=> {return t('last_update') } , field: "DTULTATURECE", checkboxSelection: false, filter: "agTextColumnFilter",
            resizable: true, sortable: true,
            maxWidth: 150
        }
    ],
    onCellValueChanged:saveNewPlate,
    onRowDoubleClicked: onPlateRowDbClicked,
    suppressRowClickSelection:true,
    getRowStyle: function({data}){
        if(data.PRATOATIVO === 'N' || (data.IDUTRPADCA === 'N' && data.TIPO_RECEITA === 'Padrão') || 
            (data.TIPO_RECEITA === 'Sem Receita')){
            return {"color": "red"};
        } else {
            return {};
        }
    }
};

const updatePlateRecipe = ({data}) => {
    PlateGroupsService.updatePlateRecipe(data).then((result) => {
        if(result && result.error){
            throw result;
        }else if(result){
            Util.showSuccessNotification({ title: t("plate_recipe_saved")});
        }
    }).catch((e = {}) => {
        Util.showErrorNotification({ title: t("unable_to_save_plate_recipe"), text: e.error });
    });
};

const recipeGrid = {
    columnDefs:[
        {
            headerValueGetter: ()=> {return t('code') } , field: "CDARVPROD", checkboxSelection: false, filter: "agTextColumnFilter",
             resizable: true, sortable: true, maxWidth: 150, 
            valueFormatter: ({ value }) => insertChar(value, serviceInstance.CDPICTPROD, ".")
        },
        {
            headerValueGetter: ()=> {return t('product') } , field: "NMPRODUTO", checkboxSelection: false, filter: "agTextColumnFilter",
             resizable: true, sortable: true, maxWidth: 500
        },
        {
            headerValueGetter: ()=> {return t('amount') } , field: "QTPRODUTO", checkboxSelection: false, filter: "agTextColumnFilter",
             editable: true, resizable: true, sortable: true, maxWidth: 149, valueFormatter: currencyValueFormatter
        },
        {
            headerValueGetter: ()=> {return t('unit') } , field: "SGUNIDADE", checkboxSelection: false, filter: "agTextColumnFilter",
              resizable: true, sortable: true, maxWidth: 149
        }
    ],
    onCellValueChanged: (params) => {
        let value = params.data.QTPRODUTO;
        
        if (typeof value === "string") {
            value = value.replace(",", ".");
            value = parseFloat(value);
        }
        params.data.QTPRODUTO = value;
        params.node.setDataValue(params.column.colId, value);
        updatePlateRecipe(params);
    }
};

const removeNewRowOnRowDeselection = function(params){
    let gridApi = params.api;
    let selectedRow = gridApi.getSelectedRows();

    if(selectedRow.length && !selectedRow[0].__is_new_row){
        let toRemoveRows = [];

        gridApi.forEachNode(function(row){
            if(row.data.__is_new_row){
                toRemoveRows.push(row.data);
            }
        });

        gridApi.updateRowData({remove:toRemoveRows});
    }
};

const onChangeMainPanelCollapse = function(collapsed){
    if(!collapsed){
        serviceInstance.platesGridConfiguration.setRowData([]);
        serviceInstance.platesGridConfiguration.hideFilterOverlay = false;
        serviceInstance.platesGridConfiguration.showLoadingOverlay = false;
        serviceInstance.platesGridConfiguration.disablePlateAdd = true;
        serviceInstance.platesGridConfiguration.disablePlateDel = true;
    }
};

const serviceInstance = {
    groupGridConfiguration,
    platesGridConfiguration,
    onGroupRowClicked,
    plateGroupStandardGridConfig,
    plateGroupGroupingGridConfig,
    grouplessPlatesGridConfig,
    deletePlateGroupStandard,
    deletePlateGroupGrouping,
    delPlateRegister,
    onChangeMainPanelCollapse,
    removeNewRowOnRowDeselection,
    delPlateGroup,
    exportGroupPlate,
    onPlateRowDbClicked,
    recipeGrid,
    callProcedureExportCadOtimizador
};

export default serviceInstance;
